import { AutocompleteFormInput, IAutocompleteFormInput } from "./AutocompleteFormInput";

export type { IAutocompleteFormInput };
export default AutocompleteFormInput;
